import { withTranslation } from "next-i18next";
import Offcanvas from "@components/core/Offcanvas";

function ProductDetailsOffCanvas({ product, opened, close, t }) {
  const colors = product.characteristics.flatMap((c) => (c.type === "color" ? c.value : []));

  return (
    <Offcanvas
      title={t("product:product_description_title")}
      show={opened}
      onHide={close}
      placement="bottom"
    >
      <div className="container product-details-offcanvas-container">
        <div className="product-details-offcanvas-content">
          <h3 className="mb-4 pb-2">{product.name}</h3>

          {product.description && (
            <div className="product-details-offcanvas-section">
              <p className="mb-2 font-weight-bold">
                {t("product:description_section_title")}
              </p>
              <p className="mb-0 text-gray preline">
                {product.description}
              </p>
            </div>
          )}

          {product.brand.display_description && (
            <div className="product-details-offcanvas-section">
              <p className="mb-2 font-weight-bold">
                {t("product:brand_section_title")}
              </p>
              <p className="mb-0 text-gray preline">
                {product.brand.description}
              </p>
            </div>
          )}

          {(product.shooting_model || product.recommandations) && (
            <div className="product-details-offcanvas-section">
              <p className="mb-2 font-weight-bold">
                {t("product:size_section_title")}
              </p>
              {product.shooting_model && (
                <div className="d-flex flex-row">
                  <div className="bullet-point">
                    &bull;&nbsp;
                  </div>
                  <p className="mb-0 text-gray">
                    {t('product:shooting_model_height', {
                      name: product.shooting_model.name,
                      centimeters: product.shooting_model.height,
                    })}
                    {product.shooting_model.description && (' ' + product.shooting_model.description)}
                  </p>
                </div>
              )}
              {product.recommandations && (
                <div className="d-flex flex-row">
                  <div className="bullet-point">
                    &bull;&nbsp;
                  </div>
                  <p className="mb-0">
                    {t(`product:${product.recommendations}`)}
                  </p>
                </div>
              )}
            </div>
          )}

          {(product.composition || colors.length > 0) && (
            <div className="product-details-offcanvas-section">
              <p className="mb-2 font-weight-bold">
                {t("product:composition_colors_section_title")}
              </p>
              <div>
                {product.composition && (
                  <div className="d-flex flex-row">
                    <div className="bullet-point">
                      &bull;&nbsp;
                    </div>
                    <p className="mb-0 text-gray">
                      {t("product:composition_line_title")}
                      {product.composition}
                    </p>
                  </div>
                )}
                {colors.length > 0 && (
                  <div className="d-flex flex-row">
                    <div className="bullet-point">
                      &bull;&nbsp;
                    </div>
                    <p className="mb-0 text-gray">
                      {t("product:colors_line_title")}
                      {colors.map((color) => t(`catalog:filters.colors.${color}`)).join(", ")}
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </Offcanvas>
  );
}

export default withTranslation(["product", "catalog"])(ProductDetailsOffCanvas);
